<template>
  <SimpleModal
    :active="statusModalActive"
    appearance="secondary"
    class="status-modal"
    @close="statusModalActive = false"
  >
    <div
      v-if="statusModalActive"
      class="has-padding-4 is-flex direction-column justify-center align-center"
    >
      <div
        :class="[`status-modal-badge-${statusObject.status ? 'ok' : 'ko'}`]"
        class="status-modal-badge"
      >
        <span class="modal-badge-icon" />
      </div>
      <label class="status-modal-label">{{ statusObject.message }}</label>
    </div>
    <template #customFooter>
      <footer class="status-modal-footer">
        <a @click="closeStatusModal()">
          {{ $t('comps.StatusModal.closeButton') }}
        </a>
      </footer>
    </template>
  </SimpleModal>
</template>

<script>
import SimpleModal from '@/components/modals/SimpleModal.vue';

export default {
  name: 'StatusModal',
  components: {
    SimpleModal,
  },
  // mixins/modal rimosso: usa statusModalActive proprio, non modalActive.
  data() {
    return {
      statusObject: {},
      statusModalActive: false,
    };
  },
  mounted() {
    // Vue 3: $bus mitt → .on/.off (era $on/$off). Handler memorizzato per off mirato.
    this.handleShowStatusModal = (statusObject) => {
      this.statusModalActive = true;
      this.statusObject = statusObject;
    };
    this.$bus.on('showStatusModal', this.handleShowStatusModal);
  },
  unmounted() {
    this.$bus.off('showStatusModal', this.handleShowStatusModal);
  },
  methods: {
    closeStatusModal() {
      this.statusModalActive = false;
      if (this.statusObject.afterCloseCallback) this.statusObject.afterCloseCallback();
    },
  },
};
</script>

<style lang="scss">


.status-modal {
  .status-modal-footer {
    padding: 1.5rem;
    background-color: $grey-solitude;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    display: flex;
    justify-content: center;
    color: $primary;
  }

  .status-modal-badge {
    @include icon-shape(5.3rem, 14px, 0, 50%);
  }
  .status-modal-label {
    color: $primary;
    font-size: $size-7;
    padding-top: 2rem;
  }
  .status-modal-badge.status-modal-badge-ok {
    .modal-badge-icon {
      position: relative;
    }
    .modal-badge-icon:after {
      content: '';
      position: absolute;
      width: 27px;
      height: 4px;
      left: -8px;
      top: -3px;
      background-color: $white;
      transform: rotate(-45deg);
      border-radius: 2px;
      box-sizing: border-box;
      box-shadow: -2px 3px 3px 0px rgba(0,0,0,0.30);
    }

    .modal-badge-icon:before {
      content: '';
      position: absolute;
      width: 4px;
      height: 17px;
      left: -10px;
      top: -6px;
      transform: rotate(-45deg);
      border-radius: 2px;
      box-sizing: border-box;
      background-color: $white;
      box-shadow: -2px 1px 3px 0px rgba(0,0,0,0.30);
    }
    background-color: $green;
  }
}


</style>
